import styled, { keyframes } from 'styled-components'

type Props = {
	color: string
	width: number
}

const dash = keyframes`
	0% {
		stroke-dasharray: 0, 1.576;
		stroke-dashoffset: 0;
	}

	50% {
		stroke-dasharray: 0.788, 1.576;
		stroke-dashoffset: -0.118;
	}

	100% {
		stroke-dasharray: 0.788, 1.576;
		stroke-dashoffset: -1;
	}
`

export const Circle = styled.circle.attrs<Props>(({ width }) => ({
	r: 16 - 1.309 * width,
	strokeWidth: 2.618 * width,
	pathLength: 1,
}))`
	animation: 1.4s ease-in-out infinite both ${dash};
	fill: transparent;
	stroke: ${({ color }) => color};
`
